import React, { useState, useRef } from "react";
import { Configuration, OpenAIApi } from "openai";
import { BlockMath, InlineMath } from "react-katex";
import { splitInlineLatex, joinLatexBlocks } from "./utils";

const defaultSolution = [
  "We can start by factoring out the constant 2 from the numerator and using a substitution to simplify the integral: ",
  "",
  "Let u = cos(2θ) → du = -2sin(2θ) dθ  ",
  "Then the integral becomes: ",
  "",
  "$\\int \\frac{2-sin(2 \\theta)}{cos(2 \\theta)} d\\theta$ ",
  "",
  "$=2\\int \\frac{1}{\\cos(2 \\theta)}d \\theta- \\int \\frac{\\sin(2 \\theta)}{\\cos(2 \\theta)} d \\theta$",
  "",
  "$=2\\int \\sec(2\\theta) d\\theta - \\int \\tan(2\\theta) d\\theta$ ",
  "",
  "$=2\\frac{1}{2}\\ln|\\sec(2\\theta)+\\tan(2\\theta)| - \\frac{1}{2}\\ln|\\cos(2\\theta)|+C$ ",
  "",
  "$=\\ln|\\sec(2\\theta)+\\tan(2\\theta)| - \\frac{1}{2}\\ln|\\cos^2(\\theta)|+C$ ",
  "",
  "$=\\ln|\\sec(2\\theta)+\\tan(2\\theta)| - \\ln|\\cos(\\theta)|+C$ ",
  "",
  "$=\\boxed{\\ln|\\frac{\\sec(2\\theta)+\\tan(2\\theta)}{\\cos(\\theta)}|+C}$",
];

const MixedContent = ({ line }) => {
  // const expressions = [];
  // const beforeMath = [];
  // const afterMath = [];

  const [text, expressions] =
    line[0] === "$" && line[line.length - 1] === "$"
      ? [[""], [line.replaceAll("$", "")]]
      : splitInlineLatex(line);

  // console.log("LINE", line, text, expressions);

  return (
    <p>
      {text.map((text, i) => (
        <>
          {text}
          {i < expressions.length && <InlineMath math={expressions[i]} />}
        </>
      ))}
    </p>
  );
};
const Solution = ({ lines = defaultSolution }) => {
  return (
    <>
      {joinLatexBlocks(lines).map((line) => (
        <>
          {line.length === 0 ? (
            <br />
          ) : (
            <>
              {line.indexOf("latex:") !== -1 ||
              (line.indexOf("\\") !== -1 && line.indexOf("$") === -1) ? (
                <>
                  <BlockMath
                    math={line
                      .substring(
                        line.indexOf("latex:") === -1
                          ? 0
                          : line.indexOf("latex:") + 6
                      )
                      .replaceAll("$", "")}
                  />
                </>
              ) : (
                <>
                  {line.indexOf("$") === -1 && line.indexOf("\\" === -1) ? (
                    <p>{line}</p>
                  ) : (
                    <MixedContent line={line} />
                  )}
                </>
              )}
            </>
          )}
        </>
      ))}
    </>
  );
};

const Solve = ({ expression }) => {
  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);
  const [code, setCode] = useState("");
  const codeRef = useRef(null);

  async function fetchSolution() {
    if (!expression || expression.length < 2) {
      setResult("There isn't anything to solve.");
      return;
    }

    setLoading(true);
    const res = await fetch("/solve", {
      method: "GET",
      headers: {
        expression,
      },
    });
    const data = await res.json();
    if (data.status === "failure") {
      alert("Something went wrong. Please try again later. ");
      setLoading(false);
    }
    // console.log(data);
    // console.log(data.result);
    const lines = data.result.split("\n");
    // console.log(lines);

    setLoading(false);
    setResult(lines);
  }
  const getOpacity = () => (authenticated ? "opacity-100" : "opacity-20");
  const codes = ["rawlings", "sammamish", "please"];
  const authenticate = () => {
    if (codes.indexOf(code.toLowerCase()) !== -1) {
      setAuthenticated(true);
    } else {
      alert("Invalid Code!");
      codeRef.current.value = "";
    }
  };
  return (
    <div className="py-6">
      <div className={"relative"}>
        <section className={getOpacity()}>
          <button
            className={`btn btn-accent ${loading ? "loading" : ""}`}
            onClick={() => fetchSolution()}
          >
            Solve
          </button>
          {!loading && (
            <section className="w-full  py-5 max-w-full solution-wrapper">
              <h2 className="text-3xl mb-1 font-bold">Solution: </h2>
              {result ? <Solution lines={result} /> : <Solution />}
            </section>
          )}
        </section>
        {!authenticated && (
          <div className="w-full py-3  absolute top-1/4 opacity-100">
            <h2 className="font-semibold text-xl">
              Enter Access Code to use Solve Feature
            </h2>
            <div className="form-control mt-3 w-full lg:w-max pr-3 lg:px-0">
              <div className="input-group">
                <input
                  type="text"
                  placeholder="Access Code"
                  className="w-64 input input-error input-bordered"
                  onChange={(e) => setCode(e.target.value)}
                />
                <button
                  ref={codeRef}
                  className="btn-error px-3 text-base-300 btn-square"
                  onClick={() => authenticate()}
                >
                  Go
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Solve;
